module.exports = __webpack_public_path__ + "img/PP_Sword_0018.45ba25e0.png";